var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sweden",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_199",
    "data-name": "Ellipse 199",
    cx: 14.933,
    cy: 14.972,
    rx: 14.933,
    ry: 14.972,
    transform: "translate(0.134 0)",
    fill: "#ffda44"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319",
    transform: "translate(-0.001 0.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2595",
    "data-name": "Path 2595",
    d: "M200.348,13.018H218.4A14.934,14.934,0,0,0,200.348.356V13.018h0Z",
    transform: "translate(-188.789)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2596",
    "data-name": "Path 2596",
    d: "M9.831,42.325v-11.2a14.98,14.98,0,0,0-7.664,11.2H9.831Z",
    transform: "translate(-2.167 -29.307)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2597",
    "data-name": "Path 2597",
    d: "M9.831,289.391H2.167a14.98,14.98,0,0,0,7.664,11.2v-11.2Z",
    transform: "translate(-2.167 -272.468)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2598",
    "data-name": "Path 2598",
    d: "M200.348,289.391v12.662A14.934,14.934,0,0,0,218.4,289.391H200.348Z",
    transform: "translate(-188.789 -272.468)",
    fill: "#0052b4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSe);
export default __webpack_public_path__ + "static/media/SE.55ca4c49346c8012c6d0836bfa68d904.svg";
export { ForwardRef as ReactComponent };